module.exports = __webpack_public_path__ + "static/media/logo-2024.17502259.png";